<template>
  <div>
    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <form-button @click="sub">开始结算</form-button>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="110px"
        :model="conditions"
        :rules="rules"
        :show-message="false"
      >
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="结算周期起" prop="startDate">
              <el-date-picker
                v-model="conditions.startDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="结算周期止" prop="endDate">
              <el-date-picker
                v-model="conditions.endDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="发货仓库" prop="warehouse">
              <el-select v-model="conditions.warehouse" placeholder="" clearable>
                <el-option
                  v-for="item in selectDataOptions['Warehouse']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户编码">
              <wly-input
                v-model="conditions.customerCode"
                input-type="customer"
                clearable
                @enter="handleEnter"
                @handleSuffixClick="showDialog = true"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input v-model="conditions.customerName" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="签收日期起" prop="signStartDate">
              <el-date-picker
                v-model="conditions.signStartDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="签收日期止" prop="signEndDate">
              <el-date-picker
                v-model="conditions.signEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      title="客户选择"
      width="70%"
    >
      <client-select v-if="showDialog" ref="clientSelect" mode="RELATION" />
      <div slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import ClientSelect from '@/components/dialog/ClientSelect'

export default {
  components: { ClientSelect },
  data() {
    const rules = {
      endDate: [{ required: true, message: '请选择结算周期止', trigger: 'change' }],
      startDate: [{ required: true, message: '请选择结算周期起', trigger: 'change' }]
      // warehouse: [{ required: true, message: '请选择发货仓库', trigger: 'change' }]
    }
    return {
      errorList: [],
      rules,
      showDialog: false,
      selectDataOptions: {},
      conditions: {
        'endDate': '',
        'startDate': '',
        'warehouse': '',
        'signStartDate': '',
        'signEndDate': '',
        customerCode: '',
        customerName: ''
      }
    }
  },
  created() {
    this.getSelectDictDataOrigin('Warehouse')
  },
  methods: {
    sub() {
      this.$refs.form.validate((valid, err) => {
        if (valid) {
          this.errorList = []
          this.$emit('check', this.conditions)
        } else {
          this.errorList = [`有${Object.values(err).length}项必填项目未填写`]
          return false
        }
      })
    },
    // 控件回车
    async handleEnter(e, type, data) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return

      this.conditions.customerCode = data.partner
      this.conditions.customerName = data.name_org1
    },
    async handleSubmit() {
      const data = await this.$refs.clientSelect.submitForm()
      if (!data) return

      this.conditions.customerCode = data.partner
      this.conditions.customerName = data.name_org1
      this.showDialog = false
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/components/DeliveryFeeStep1.vue